import React from 'react';
import './blocked.css';
import FailSvg from 'src/Components/Common/Svg/FailSvg';

const Blocked = (props) => {
  return (
    <div className='otp-blocked-main-container'>
      <FailSvg />
      <h2 className="entered-wrong-otp">You've entered 3 invalid OTPs</h2>
      <p className='otp-blocked-message'>
        For your security, you've been temporarily blocked from requesting new
        OTPs. Please try again in 24 hours.
      </p>
      <button className='opt-close-button' onClick={props.close}>
        Ok, got it
      </button>
    </div>
  );
};

export default Blocked;
